// extracted by mini-css-extract-plugin
export default {"Modal":"style_Modal__C7AjA","visible":"style_visible__UOHzm","content":"style_content__o4nDx","groupInput":"style_groupInput__o-Zcq","btnInput":"style_btnInput__nFNHI"};